module.exports = __webpack_public_path__ + "media/images/app/colors/colors-blue-0ac2e0fe44ad9b381cfa1807f1144368.webp";